import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { Fragment } from "react";
import { Transition } from "../../Modal/ModalConstants";
import CloseIcon from "@mui/icons-material/Close";
import "./mcdo.scss";

type IProps = {
  open: boolean;
  onClose: (state: boolean) => void;
  label: string;
  infoData: any;
};

function ViewInfoPopup({ open, onClose, label, infoData }: IProps) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        className="assets-information-popup"
        TransitionComponent={Transition as any}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle id="responsive-dialog-title" className="flex">
          {label}
          <CloseIcon
            className="assets-info-popup-close-icon pointer"
            onClick={() => {
              onClose(false);
            }}
          />
        </DialogTitle>
        <DialogContent dividers className="info-dialog-content">
          <div className="info-dialog-container">
            {Object.entries(infoData).map(([key, value], index) => (
              <Fragment key={index}>
                <div className="info-dialog-key">{key}</div>
                <div className="info-dialog-info">
                  {value && (typeof value === "string" || typeof value === "number") ? value : ""}
                  {value && typeof value === "object" ? (
                    <Fragment>
                      {Object.entries(value).map(([key, val], idx) => (
                        <div key={idx}>
                          {key}: {val}
                        </div>
                      ))}
                    </Fragment>
                  ) : (
                    ""
                  )}
                </div>
              </Fragment>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus
            onClick={() => {
              onClose(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ViewInfoPopup;
